import { useEffect, useState } from "react";
import { useRouter } from 'next/router';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from "next-i18next";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ClipLoader from "react-spinners/ClipLoader";
import {
    create_account_saga,
    add_card_saga,
    card_inputs_value,
    delete_card_saga,
    master_card_saga,
    master_card
} from "../store/actions/card";
import { get_my_data_saga } from "../store/actions/my-info";
import authApi, { setApiAuthorizationHeader } from '../services/authinstance';
import keys from '../services/keys';
const error_notify = (text) => toast.error(text ? text : "error", {
    position: toast.POSITION.TOP_CENTER
});
const Card = (props) => {
    const dispatch = useDispatch();
    const [focus, setFocus] = useState(false);
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [activeInput, setActive] = useState(false);
    const card_list = useSelector(state => state.card_list);
    const user = useSelector(state => state.getme.data);
    const translate = useSelector(state => state.translate);
    const { t } = useTranslation();
    const router = useRouter();
    const handleClick = (href) => {
        router.push(href);
    };
    const create_account = () => {
        return dispatch(create_account_saga(props.token));
    };
    const add_card = () => {
        return dispatch(add_card_saga({
            translate,
            token: props.token, data: card_list.form,
            cb: () => {
                router.back(),
                    master_card_saga();
            }
        }));
    };
    const get_my_data = () => {
        return dispatch(get_my_data_saga({ token: props.token }));
    };
    const delete_card = () => {
        const { open_modal, ...data } = open;
        setLoading(true);
        return dispatch(delete_card_saga({
            token: props.token, ...data, stripe_id: user.stripe_client_id, cb: () => {
                setLoading(false);
                setOpen(false);
            }
        }));
    };
    const card_input = (data) => {
        return dispatch(card_inputs_value(data));
    };
    const keyPress = (e) => {
        if (e.key === "Enter") {
            add_card();
        };
    };
    const get_card = async () => {
        setApiAuthorizationHeader(props.token);
        const response = await authApi.get(`${keys.SERVER_URL}schedule/get-cards/`);
        dispatch(master_card({ ...response.data }));
    };
    useEffect(() => {
        get_card();
    }, []);
    const body = (
        <div >
            <p className="modal-title">{t("deleteLabel")}</p>
            <div className="modal-line"></div>
            {loading
                ? <div className="w-100 d-flex justify-content-center">
                    <ClipLoader color="#464646" size={15} /></div>
                : <div className="d-flex justify-content-evenly">
                    <span className="button-title"
                        onClick={() => delete_card()}>{t("yes")}</span>
                    <span className="button-title">{t("no")}</span>
                </div>}
        </div>);
    useEffect(() => {
        if (props.status === "failed") {
            error_notify();
        }
        if (props.stripe) {
            get_my_data();
        }
        if (props.loggedIn) return; // do nothing if the user is logged in
        router.push("/login");
    }, [props.loggedIn]);

    return {
        card_list,
        translate,
        router,
        activeInput,
        open,
        user,
        body,
        focus,
        setActive,
        create_account,
        add_card,
        card_input,
        keyPress,
        handleClick,
        setOpen,
        setFocus

    };
};
export default Card;